import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const opsNotificationsPersonalSettingsRoute: InvariantJiraRoute = {
	name: 'personal-settings-ops-notifications',
	path: '/jira/settings/personal/alert-notifications',
};
